// WebSocket event names constants
export const WEBSOCKET_EVENTS = {
  // ===== CHAT EVENTS =====
  MESSAGE_SENT: 'message-sent',
  NEW_MESSAGE: 'new-message',
  SYSTEM_MESSAGE: 'system_message',
  TYPING_INDICATOR: 'typing-indicator',
  MESSAGE_READ: 'message-read',
  MESSAGE_DELIVERED: 'message-delivered',
  USER_ONLINE: 'user-online',
  USER_OFFLINE: 'user-offline',
  MESSAGE_REACTION: 'message-reaction',
  MESSAGE_REACTION_BROADCAST: 'message-reaction-broadcast',
  CHAT_MENTION: 'chat-mention',

  // ===== NOTIFICATION EVENTS =====
  NEW_COMMENT: 'new-comment',
  BOT_REVIEW_COMPLETE: 'bot-review-complete',
  NEW_CODE_REVIEW: 'new-code-review',
  NEW_MEME_POST_REACTION: 'new-meme-post-reaction',
  NEW_MEME_COMMENT: 'new-meme-comment',
  NEW_COMMENT_REACTION: 'new-comment-reaction',
  NEW_POST_MENTION: 'new-post-mention',
  NEW_MEME_COMMENT_REPLY: 'new-meme-comment-reply',
  NEW_ONLINE_TEST_ASSIGNMENT: 'new-online-test-assignment',

  // ===== SESSION EVENTS =====
  TERMINATE_SESSION: 'terminate-session',
} as const

export type WebSocketEventName = (typeof WEBSOCKET_EVENTS)[keyof typeof WEBSOCKET_EVENTS]
